import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchDashboardSummary } from '../api/dashboardApi';

interface City {
    _id: string;
    name_ku: string;
    name_eng: string;
    name_ar: string;
}

interface Customer {
    id: string;
    name: string;
    phone1: string;
    phone2: string;
    customerCode: string;
    city: City;
    createdAt: string;
    updatedAt: string;
}

interface Order {
    // Define your Order structure if needed
    id?: string;
}

interface DashboardSummary {
    totalCustomers: number;
    totalUsers: number;
    totalOrders: number;
    totalCities: number;
    latestCustomers: Customer[];
    latestOrders: Order[];
}

interface DashboardContextProps extends DashboardSummary {
    fetchSummary: () => void;
}

const DashboardContext = createContext<DashboardContextProps | undefined>(undefined);

export const DashboardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [summary, setSummary] = useState<DashboardSummary>({
        totalCustomers: 0,
        totalUsers: 0,
        totalOrders: 0,
        totalCities: 0,
        latestCustomers: [],
        latestOrders: [],
    });

    const fetchSummary = async () => {
        const data = await fetchDashboardSummary();
        setSummary(data);
    };

    useEffect(() => {
        fetchSummary();
    }, []);

    return (
        <DashboardContext.Provider value={{ ...summary, fetchSummary, }}>
            {children}
        </DashboardContext.Provider>
    );
};

export const useDashboard = () => {
    const context = useContext(DashboardContext);
    if (!context) throw new Error('useDashboard must be used within a DashboardProvider');
    return context;
};
